import { initialClients } from './initialState';

export const state = {
  clients: initialClients,
};
